
import { GearOwner } from "@/types";

// Define persona owners with their bios
export const ownerPersonas: GearOwner[] = [
  {
    id: "owner-1",
    name: "Rachel S.",
    imageUrl: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?auto=format&fit=crop&w=300&q=80",
    rating: 4.8,
    reviewCount: 24,
    responseRate: 98,
    bio: "Hey there! I'm Rachel, a marketing manager from San Diego who loves being active whenever I can escape the office. \
      As a weekend warrior (1-2x/month), I've built a small collection of quality gear that I'd love to share when I'm not using it. \
      I'm all about trying before buying, and I hope my collection helps you do the same without breaking the bank. Drop me a message \
      with any questions!",
    location: "Los Angeles, CA",
    memberSince: "2022",
    personality: "Weekend Warrior"
  },
  {
    id: "owner-2",
    name: "Chris T.",
    imageUrl: "https://images.unsplash.com/photo-1581092795360-fd1ca04f0952?auto=format&fit=crop&w=300&q=80",
    rating: 4.9,
    reviewCount: 47,
    responseRate: 95,
    bio: "What's up! I'm Chris. I work remotely as a project manager, which means I get to hit the trails 3-4 times a week. \
      I've built up a killer collection of mountain bikes over the years, from trail bikes to enduro rigs. I'm active in several \
      MTB forums and always dialing in the perfect setup for our local terrain. My bikes are meticulously maintained and \
      professionally serviced - I treat them better than my car!",
    location: "Los Angeles, CA",
    memberSince: "2020",
    personality: "Super Gear Lender"
  },
  {
    id: "owner-3",
    name: "Maya L.",
    imageUrl: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=300&q=80",
    rating: 4.7,
    reviewCount: 18,
    responseRate: 92,
    bio: "Hi, I'm Maya! I live the van life and work as a remote UX designer, chasing adventures wherever I can find them. \
      Being constantly on the move means I can't own tons of gear, but I do have some quality pieces that I can lend out when I'm \
      in your area. I know the struggle of finding good rentals in a new spot, so I make sure my gear descriptions are comprehensive \
      and the prices are fair. Let me know if you need advice about local spots too!",
    location: "Los Angeles, CA",
    memberSince: "2022",
    personality: "Nomadic Renter"
  },
  {
    id: "owner-4",
    name: "Tony M.",
    imageUrl: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=300&q=80",
    rating: 4.9,
    reviewCount: 89,
    responseRate: 99,
    bio: "I'm Tony, co-owner of Mountain Edge Board Shop. We specialize in high-performance gear for any outdoor adventure. \
      Our demo program lets you try before you buy, and if you decide to purchase after your demo, we'll apply the rental fee \
      to your purchase! We carry brands that are hard to find elsewhere, including some limited editions. Stop by our shop for \
      expert advice or rent through this platform for convenience.",
    location: "Los Angeles, CA",
    memberSince: "2020",
    personality: "Local Shop Owner"
  },
  {
    id: "owner-5",
    name: "Dustin R.",
    imageUrl: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=300&q=80",
    rating: 4.8,
    reviewCount: 33,
    responseRate: 97,
    bio: "Hey! I'm Dustin, an avid mountain biker with a passion for the trails. I've been riding for over a decade and \
      have built up quite a collection of high-end bikes. From XC racing to downhill, I've got bikes for every style of riding. \
      I maintain all my bikes to the highest standard and can help you choose the perfect ride for your skill level and the local trails. \
      Feel free to ask me about the best spots to ride in LA - I know all the secret trails!",
    location: "Los Angeles, CA",
    memberSince: "2021",
    personality: "Gear Lender"
  },
  {
    id: "owner-6",
    name: "Jessie K.",
    imageUrl: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=300&q=80",
    rating: 4.6,
    reviewCount: 21,
    responseRate: 94,
    bio: "Aloha! I'm Jessie, a yoga instructor in Encinitas with a passion for anything outdoors. I've accumulated quite a collection \
      of gear for different conditions, and I'm happy to share them when I'm not using them. My quiver includes everything from \
      beginner-friendly daily drivers to high-performance equipment. I'm pretty flexible with pickup arrangements and can usually meet \
      near Downtown. The extra income helps fund my next gear purchase (don't tell my partner, haha!).",
    location: "Los Angeles, CA",
    memberSince: "2023",
    personality: "Quiver Lender"
  },
  {
    id: "owner-7",
    name: "Jamie M.",
    imageUrl: "https://images.unsplash.com/photo-1548690312-e3b507d8c110?auto=format&fit=crop&w=300&q=80",
    rating: 4.5,
    reviewCount: 12,
    responseRate: 90,
    bio: "Hey there! I'm Jamie, an outdoor enthusiast who loves to share my gear with the community. I carefully maintain all my equipment and \
      am always happy to provide tips on getting the most out of your rental. Feel free to message me with any questions!",
    location: "Los Angeles, CA",
    memberSince: "2022",
    personality: "Casual Lender"
  },
  {
    id: "owner-8",
    name: "Taylor S.",
    imageUrl: "https://images.unsplash.com/photo-1566492031773-4f4e44671857?auto=format&fit=crop&w=300&q=80",
    rating: 4.9,
    reviewCount: 56,
    responseRate: 96,
    bio: "What's up, I'm Taylor! As a former pro mountain biker, I've got an incredible collection of high-end bikes. From World Cup race rigs \
      to enduro beasts, I love sharing my knowledge and helping others experience pro-level gear. Every bike is maintained to race standards \
      and tuned for the local trails. Let me help you find the perfect ride for your skill level and riding style!",
    location: "Los Angeles, CA",
    memberSince: "2020",
    personality: "Super Gear Lender"
  },
  {
    id: "owner-9",
    name: "Jordan T.",
    imageUrl: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&w=300&q=80",
    rating: 4.7,
    reviewCount: 29,
    responseRate: 93,
    bio: "Jordan here - outdoor gear collector and adventure seeker. I believe everyone should have access to quality equipment, which is why I \
      started lending my gear. I'm constantly updating my collection with the latest and greatest, so you'll always find something exciting to try!",
    location: "Los Angeles, CA",
    memberSince: "2022",
    personality: "Gear Aficionado"
  },
  {
    id: "owner-10",
    name: "Casey K.",
    imageUrl: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=300&q=80",
    rating: 4.8,
    reviewCount: 31,
    responseRate: 95,
    bio: "Hey, I'm Casey! I got into mountain biking during the pandemic and fell in love with exploring LA's trail networks. \
      I've got a few quality bikes that I love sharing with others when I'm not riding. Whether you're looking for a mellow cruise on fire roads \
      or want to try some beginner-friendly singletrack, I can help set you up with the right bike. I know all the best beginner-friendly trails \
      in the area and always happy to share route recommendations!",
    location: "Los Angeles, CA",
    memberSince: "2021",
    personality: "Gear Lender"
  }
];
